module.exports = __webpack_public_path__ + "img/img_32360_0_0.402b641b.png";